var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject } from 'vue-property-decorator';
import { arrayify } from "../../../../lib/utils/array";
import { INJECT_UICORE_FORM, INJECT_UICORE_RENDERER } from "../../../../lib/utils/consts";
import { formOverridePropsConsumer } from './formOverrideProps';
import { normalizeFormValidateResult } from './FormValidateResult';
let FormEditorBase = class FormEditorBase extends Vue {
  constructor() {
    super(...arguments);
    // data
    this.validateStatus = '';
    this.validateResults = [];
  }
  get hasError() {
    return this.validateStatus === 'error';
  }
  mounted() {
    var _this$ucForm;
    (_this$ucForm = this.ucForm) === null || _this$ucForm === void 0 || _this$ucForm.editors.add(this);
  }
  beforeDestroy() {
    var _this$ucForm2;
    (_this$ucForm2 = this.ucForm) === null || _this$ucForm2 === void 0 || _this$ucForm2.editors.delete(this);
  }
  /** @abstract 重置输入框内容，支持异步 */
  reset() {
    // 空方法，组件应该覆盖
  }
  /** @abstract 校验输入框内容，支持异步，发现错误需要 throw 出 Error */
  validate() {
    // 空方法，组件应该覆盖
  }
  /**
   * 校验输入框，并更新当前输入框的 validateResults、validateStatus 等状态
   *
   * 直接调用 validate 可能会坑，而且不一定是异步的，所以这里有一个这样的东西
   *
   * 这个不会 throw Error
   */
  async validateAndUpdateStatus() {
    this.validateStatus = 'validating';
    const rawResult = await Promise.resolve().then(() => this.validate()).catch(err => err).then(ans => arrayify(ans));
    this.setValidateResult(rawResult.length ? 'error' : 'success', rawResult);
    return this.validateResults;
  }
  /**
   * 校验输入框，更新当前输入框的 validateResults、validateStatus 等状态
   *
   * 如果遇到错误，会更新状态后，throw 一个错误出来
   */
  async validateAndThrow() {
    const ans = await this.validateAndUpdateStatus();
    if (ans.length > 0) throw ans[0].error || new Error(ans[0].message);
  }
  /**
   * 设置校验结果，仅用于展示而已。
   */
  setValidateResult(status, messages) {
    this.validateStatus = status || '';
    this.validateResults = arrayify(messages).map(x => normalizeFormValidateResult(this, x));
  }
  /**
   * 清除校验状态
   */
  clearValidate() {
    this.setValidateResult('', []);
  }
};
__decorate([Inject({
  from: INJECT_UICORE_FORM,
  default: null
})], FormEditorBase.prototype, "ucForm", void 0);
__decorate([Inject({
  from: INJECT_UICORE_RENDERER,
  default: null
})], FormEditorBase.prototype, "ucRenderer", void 0);
FormEditorBase = __decorate([Component({
  name: 'FormEditorBase',
  extends: formOverridePropsConsumer,
  ucMethods(decls) {
    if (typeof this.reset === 'function') {
      decls.push({
        id: 'reset',
        title: '重置为默认值',
        description: '将重置此区域内的输入框组件'
      });
    }
    if (typeof this.validate === 'function') {
      decls.push({
        id: 'validateAndThrow',
        title: '校验输入（出错就阻断流程）'
      });
    }
  }
})], FormEditorBase);
export default FormEditorBase;